import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../../lib/utils.js';

export interface ContextPillProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: ReactNode;
  icon?: ReactNode;
  trailingIcon?: ReactNode;
}

/** Workspace / Place selector — visual only; wiring via `WorkspaceProvider` in apps/web. */
export function ContextPill({
  label,
  icon,
  trailingIcon,
  className,
  type = 'button',
  ...props
}: ContextPillProps) {
  return (
    <button type={type} className={cn('ctx-pill', className)} {...props}>
      {icon}
      <strong>{label}</strong>
      {trailingIcon}
    </button>
  );
}

export type ContextPillStaticProps = HTMLAttributes<HTMLDivElement> & {
  label: ReactNode;
  icon?: ReactNode;
  trailingIcon?: ReactNode;
};

/** Non-interactive context pill (read-only display). */
export function ContextPillStatic({
  label,
  icon,
  trailingIcon,
  className,
  ...props
}: ContextPillStaticProps) {
  return (
    <div className={cn('ctx-pill', className)} {...props}>
      {icon}
      <strong>{label}</strong>
      {trailingIcon}
    </div>
  );
}
